import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";

// Async thunk for posting new item
export const addItem = createAsyncThunk(
  "items/addItem",
  async (formData, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiService.post("/items", formData);
      dispatch(getItemsDetails());
      return response.data;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors.response?.data?.errors || errors.message);
    }
  }
);
// Async thunk for editing an item
export const editItem = createAsyncThunk(
  "items/editItem",
  async ({ id,formData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiService.put(`/items/${id}`,formData);
      dispatch(getItemsDetails());
      return response.data;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

// Create AsyncThunk for fetching items details
export const getItemsDetails = createAsyncThunk(
  "items/getItemsDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.get("/items");
      return response.items;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

// Async thunk for fetching item details by ID
export const getItemById = createAsyncThunk(
  "items/getItemById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.get(`/items/${id}`);
      return response.item;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

// Async thunk for deleting items
export const deleteItem = createAsyncThunk(
  "items/deleteItem",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      await apiService.delete(`/items/${id}`);
      dispatch(getItemsDetails());
      return id; 
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

const addItemsSlice = createSlice({
  name: "items",
  initialState: {
    loading: false,
    success: false,
    error: null,
    item: null,
    items: [],
    itemDetails:null
  },
  reducers: {
    resetAddItemState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.item = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addItem.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.item = action.payload;
      })
      .addCase(addItem.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })
      // for getting all items
      .addCase(getItemsDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getItemsDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getItemsDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       // for getting all items by id
      .addCase(getItemById.pending, (state) => {
        state.loading = true;
        state.itemDetails = null;
      })
      .addCase(getItemById.fulfilled, (state, action) => {
        state.loading = false;
        state.itemDetails = action.payload;
      })
      .addCase(getItemById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // for editing items
      .addCase(editItem.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.item = action.payload;
      })
      .addCase(editItem.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })
  },
});

export const { resetAddItemState } = addItemsSlice.actions;

export default addItemsSlice.reducer;
